module.exports = __webpack_public_path__ + "static/stork-photo-1-7ea773e1bc8a8639681606050c29f5cf.jpg";